import SeeAllBtn from '../SeeAll'

import { TableContainer, Table, TableBody, TableRow, TableCell, Paper, Typography, Box } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import { LINKS } from '../../utils/constants/links'
import { type IAuthToken, type IUserProfile } from '../../redux/api/types'
import { useSelector } from 'react-redux'
import { useGetAnalyticsMutation } from '../../redux/api/userApi'
import { useEffect, useState } from 'react'

const ThinTableCell = styled(TableCell)(({ theme }) => ({
  padding: '17px 0'
}))

function createData (
  name: string,
  value: string
) {
  return {
    name,
    value
  }
}

interface IDate {
  name: string
  value: string
}

const MonthlyAnalytics: React.FC = () => {
  const theme = useTheme()
  const [analytics, setAnalytics] = useState<IDate[]>([])
  const user: IUserProfile = useSelector((state: any) => state.userState.user)
  const authToken: IAuthToken = useSelector((state: any) => state.userState.authToken)
  const [getAnalytics, { isSuccess, data, isError }] = useGetAnalyticsMutation()

  useEffect(() => {
    if (isSuccess) {
      setAnalytics([
        createData('Total Visits', data.visits.total),
        createData('Total Page Views', data.pageviews.total),
        createData('Avg. Time on Site', data.avg_sessions.total),
        createData('Avg. Actions Per Visit', data.action.total)
      ])
    }
  }, [isSuccess])

  useEffect(() => {
    if (isError) {
      setAnalytics([
        createData('Total Visits', 'Data Not Available'),
        createData('Total Page Views', 'Data Not Available'),
        createData('Avg. Time on Site', 'Data Not Available'),
        createData('Avg. Actions Per Visit', 'Data Not Available')
      ])
    }
  }, [isError])

  useEffect(() => {
    getAnalytics({}).then(() => {}).catch(() => {})
  }, [])
  return (
        <Paper sx={{
          padding: '17px 24px 32px',
          boxShadow: 0
        }}>
            <Box sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              mb: 2,
              height: '30px'
            }}>
                <Typography
                    sx={{ color: theme.palette.grey[40] }}
                    variant='caption'
                >
                    Monthly Website Analytics
                </Typography>
                <a rel="noreferrer" target='_blank' href={LINKS.WEBSITE_ANALYTICS(user, authToken)}>
                    <SeeAllBtn/>
                </a>
            </Box>
            <TableContainer>
                <Table sx={{ width: '100%' }} aria-label="Monthly Activity">
                    <TableBody>
                        {analytics.map((item, index) => {
                          const {
                            name,
                            value
                          } = item
                          return (
                                <TableRow
                                    key={index}
                                    sx={{ '& td, & th': { border: 0 } }}
                                >
                                    <ThinTableCell
                                        sx={{
                                          minWidth: '100px',
                                          color: theme.palette.grey[50]
                                        }}
                                    >
                                        {name}
                                    </ThinTableCell>
                                    <ThinTableCell
                                        align="right"
                                        sx={{
                                          minWidth: '100px',
                                          color: theme.palette.grey[70]
                                        }}
                                    >
                                        {value}
                                    </ThinTableCell>
                                </TableRow>
                          )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
  )
}

export default MonthlyAnalytics
